export const SET_LOGIN_FORM = 'SET_LOGIN_FORM';
export const SET_LOGIN_ATTRIBUTE = 'SET_LOGIN_ATTRIBUTE';
export const RESET_LOGIN_FORM = 'RESET_LOGIN_FORM';
export const SOCIAL_LOGIN_SUCCESS = 'SOCIAL_LOGIN_SUCCESS';
export const countriesThatMigrateFromNoLoyaltyToLoyalty = ['NL'];
export const PROFILING_COUNTRIES = ['GB'];
export const falsePositiveConsents = ['profilingOptIn']
export const SOCIAL_LOGIN_FLOW_TYPES = {
    LOGIN: 'login',
    REGISTER: 'register',
  };
